import * as React from "react";
import { memo } from "react";
const SvgBlackTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0v24h24L0 0Z", fill: "currentColor" }));
const Memo = memo(SvgBlackTriangle);
export default Memo;
